<template>
  <div id="feedforward">
    <div
      v-if="['leaderEngagementFeedforward', 'myLeaderFeedforward'].includes($route.name)"
      class="mainCard"
    >
      <el-page-header
        title="Go Back"
        :content="null"
        @back="$router.go(-1)"
      />
    </div>

    <h2
      v-if="$mq === 'mobile' || $mq === 'tablet'"
      class="mHead"
    >
      {{ $t('aside.feedforward') }}
    </h2>
    <CustomTabs>
      <template
        v-for="(tabName, TKey) in tabOption"
      >
        <!-- Title Slot -->
        <div
          :slot="`title${TKey + 1}`"
          :key="`Tab${TKey}`"
        >
          <div
            v-if="$mq === 'laptop' || $mq === 'desktop'"
            class="title"
          >
            {{ $t('common.lgaLongSingle') }} {{ TKey + 1 }}
          </div>
          <div class="value">
            <b>{{ lgas[tabName] }}</b>
          </div>
        </div>

        <!-- Contents Slot -->
        <div
          :slot="`content${TKey + 1}`"
          :key="`TabC${TKey}`"
          v-loading="loading"
        >
          <FeedforwardList :feedforwards="filteredFeedforwards[tabName]" />
        </div>
      </template>
    </CustomTabs>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import CustomTabs from '@/views/components/customTabs/CustomTabs.vue';
import api from '@/api';
import FeedforwardList from './FeedforwardList.vue';

export default {
  components: {
    FeedforwardList,
    CustomTabs,
  },

  data() {
    return {
      filter: 'all',
      feedforwards: null,
      loading: false,
    };
  },

  computed: {
    ...mapState({
      lgas: (state) => state.myLGAs.lgas,
      session: (state) => state.processStatus.process.session,
    }),

    filteredFeedforwards() {
      const lgas = {};

      if (!this.feedforwards) return lgas;

      ['lga1', 'lga2'].forEach((lga) => {
        if (this.feedforwards[lga]) {
          if (!lgas[lga]) lgas[lga] = null;

          if (this.filter.includes('session_') && ['desktop', 'laptop'].includes(this.$mq)) {
            if (lgas[lga] === null) lgas[lga] = {};
            lgas[lga][this.filter] = [];
            lgas[lga][this.filter] = this.feedforwards[lga].filter(
              (item) => item.session_id === this.filter,
            );
          } else {
            this.feedforwards[lga].forEach((el) => {
              if (lgas[lga] === null) lgas[lga] = {};
              if (!lgas[lga][el.session_id]) {
                lgas[lga][el.session_id] = [];
              }
              lgas[lga][el.session_id].push(el);
            });
          }
        }
      });

      return lgas;
    },

    tabOption() {
      const list = [];

      if (this.filteredFeedforwards) {
        Object.keys(this.filteredFeedforwards).forEach((key) => {
          list.push(key);
        });
      }

      return list;
    },
  },

  created() {
    this.getFeedforwards();
  },

  methods: {
    async getFeedforwards() {
      try {
        this.loading = true;
        let response;
        if (this.$route.name === 'myLeaderFeedforward') {
          response = await api.getCoachLeaderFeedForwards(this.$route.params.id);
        } else if (this.$route.name === 'leaderEngagementFeedforward') {
          response = await api.getEngagementFeedforward(this.$route.params.id);
        } else {
          response = await api.getFeedforwards();
        }
        this.feedforwards = response.data;
      } catch (err) {
        console.log(err);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#feedforward {
  .filter {
    text-align: right;
    margin-bottom: 15px;

    .el-select {
      .el-input {
        input {
          border-radius: 20px;
          background-color: transparent;
          color: white;
        }
      }
    }
  }

  .mHead {
    color: var(--themeFontColor);
    padding: 0;
  }

  .customTabs {
    .mobile {
      .title {
        padding: 0;
      }
    }
  }
}
</style>

<style lang="scss">
  #feedforward {
    .el-tabs__item {
      .value {
        font-size: 16px;
      }
    }

    .el-tabs__content {
      padding: 20px 30px;
    }

    .mobile {
      .value {
        word-break: break-word;
      }
    }
  }
</style>
